export const enum URLQueryKeys {
  // Filters
  /** @deprecated - we should be using league instead */
  SPORT = 'sports',
  LEAGUE = 'league',
  LEAGUE_NAME = 'leagueName',
  VIEW = 'view',
  HIDE_UNLISTED = 'hideUnlisted',
  ENTRY_STATUS = 'entryStatus',
  CONTEST_STATUS = 'contestStatus',
  CONTEST_FILTER = 'contestFilter',
  CONTEST_TYPE = 'contestType',
  CONTEST_TAB = 'contestTab',
  PAYOUT_FORMAT = 'payoutFormats',
  ENTRY_FEE = 'entryFee',
  SORT_BY = 'sortBy',
  SORT_ORDER = 'sortByOrder',
  COMMISSIONER_ID = 'commissionerId',
  HAS_ENTRY_FEE = 'hasEntryFee',
  ASSOCIATION = 'association',
  ENTRY_TYPES = 'entryTypes',

  // Commissioner specific
  RESTART_STATUS = 'restartStatus',
  LEAGUES = 'leagues',

  // Routing params
  REDIRECT_TO = 'redirectTo',
  REDIRECT_TO_EO = 'redirectToEO',
  REQUIRE_KYC = 'requireKyc',
  BRAND = 'brand',
  RESET_PASSWORD_SUCCESS = 'resetSuccess',
  PLATFORM = 'platform',
  CONTEST_ID = 'contestId',
  ENTRY_ID = 'entryId',
  SLATE_ID = 'slateId',
  REF = 'ref',
  EDITING = 'editingPicks',
  IS_NEW_ENTRY = 'isNewEntry',
  IS_COMMISSIONER = 'isCommissioner',
  CONTEST_USER = 'contestUser',
  UTM_SOURCE = 'utm_source',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_MEDIUM = 'utm_medium',
  UTM_CONTENT = 'utm_content',
  UTM_PARAM_CONTEST_ID = 'utm_param_contest_id',
  REF_PLATFORM = 'refPlatform',
  ENTER_CONTEST = 'enterContest',
  ACTIVE_TAB = 'activeTab',
  SEARCH_QUERY = 'q',
  CHANNEL_FOLLOWING = 'following',
  CHANNEL_FOLLOWERS = 'followers',

  // Invite Manager
  INVITES_MANAGER_FOLLOWERS = 'followers',
  INVITES_MANAGER_GROUPS = 'groups',
  INVITES_MANAGER_EMAIL = 'email',
  INVITES_MANAGER_RYP = 'RYP',
  INVITES_MANAGER_OFP = 'OFP',
  INVITES_MANAGER_LINK = 'link',
  INVITES_MANAGER_NEW = 'new',
  INVITES_MANAGER_SENT = 'sent',

  // Entrants Manager
  ENTRANTS_MANAGER_ENTRANTS = 'entrants',
  ENTRANTS_MANAGER_REVIVALS = 'revivals',
  ENTRANTS_MANAGER_ACTIVITY = 'activity',

  // Refer a friend
  REFERRAL_CODE = 'referralCode',

  // QuickPicks
  // LEAGUE = 'league',
  GAME = 'game',
  TYPE = 'type',
  PICKSDRAWER = 'picksDrawer',
  PLAYER_CARD_ID = 'playerCardId',
  PROPS = 'props',
  WITHDRAWAL_AMOUNT = 'withdrawalAmount',
  DEPOSIT_AMOUNT = 'depositAmount',
}
